import React, { useCallback, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useDispatch, useSelector } from "react-redux";
import { Loader, Image } from "../../components";
import { Headline, Paragraph } from "../../components/Typography";
import { TimelineEntity, ContainersEntity } from "../../_entities";
import useTimeout from "../../hooks/useTimeout";
import { fetchSponsors } from "../../_entities/Slides/Slides.actions";

const { fetchAppHome, fetchTicker } = ContainersEntity.actions;
const { getLogo, getDescription, getHeadline } = ContainersEntity.selectors;

const {
  fetchTimeline,
  setChapterStep,
  setCurrentChapter,
} = TimelineEntity.actions;
const { getTimelineLoading, getChapters } = TimelineEntity.selectors;

const Home = ({ history }) => {
  const dispatch = useDispatch();
  const loading = useSelector(getTimelineLoading);
  const chapters = useSelector(getChapters);
  const logo = useSelector(getLogo);
  const description = useSelector(getDescription);
  const headline = useSelector(getHeadline);

  const loadTimeline = useCallback(async () => {
    try {
      dispatch(fetchTimeline());
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  const loadHome = useCallback(async () => {
    try {
      dispatch(fetchAppHome());
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  const loadSponsors = useCallback(async () => {
    try {
      dispatch(fetchSponsors());
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  const loadTicker = useCallback(async () => {
    try {
      dispatch(fetchTicker());
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  const loadInitialChapter = useCallback(async () => {
    try {
      dispatch(setChapterStep(0));
      dispatch(setCurrentChapter(chapters[0]));
      history.push(`/chapters`);
    } catch (error) {
      console.error(error);
    }
  }, [dispatch, chapters, history]);

  useEffect(() => {
    loadHome();
    loadTimeline();
    loadTicker();
    loadSponsors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useTimeout(() => {
    loadInitialChapter();
  }, 10000);

  return loading ? (
    <Loader color="#000" />
  ) : (
    <div style={{ margin: "1rem" }}>
      <div style={{ width: "100%", height: "10vmin" }}>
        <div className="w-10">
          <Image src={logo?.url} fallback={logo?.url} type={logo?.mime} />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div style={{ width: "65%" }}>
          <Headline>{headline}</Headline>
        </div>
        <div style={{ width: "25%" }}>
          <Paragraph>
            <ReactMarkdown>{description}</ReactMarkdown>
          </Paragraph>
        </div>
      </div>
    </div>
  );
};

export default Home;
